import { Serializable } from '@core/models';

export class PrintMenuConfiguration extends Serializable {
  constructor(guid, showProductDescription, showProductFeature, showProductPrice, showSectionFreeText,
    showInTwoColumns, fontSize, lineProductHeight, clausesHeight, sectionsHeight, sectionsHeightTitle,
    showBorders, featuresSize, repeatLogoPerPage, showInformationText) {
    super();
    this.guid = guid;
    this.showProductDescription = showProductDescription;
    this.showProductFeature = showProductFeature;
    this.showProductPrice = showProductPrice;
    this.showSectionFreeText = showSectionFreeText;
    this.showInTwoColumns = showInTwoColumns;
    this.showBorders = showBorders;
    this.fontSize = fontSize;
    this.lineProductHeight = lineProductHeight;
    this.clausesHeight = clausesHeight;
    this.sectionsHeight = sectionsHeight;
    this.sectionsHeightTitle = sectionsHeightTitle;
    this.featuresSize = featuresSize;
    this.repeatLogoPerPage = repeatLogoPerPage;
    this.showInformationText = showInformationText;
  }

  serialize() {
    return {};
  }

  static toInstance(props = {}) {
    return new PrintMenuConfiguration(props.guid, props.show_product_description,
      props.show_product_feature, props.show_product_price, props.show_section_free_text,
      props.show_in_two_columns, props.font_size, props.line_product_height, props.clauses_height,
      props.sections_height, props.sections_height_title, props.show_borders, props.features_size,
      props.repeat_logo_per_page, props.show_information_text);
  }
}
